import { useContext } from "react";
import constants from "../../constants";
import AlertContext from "../../context/AlertContext";
import useCommonFunctionHooks from "../useCommonFunctionHooks";

export default function InstructionPageWizardHooks() {
  const Alert = useContext(AlertContext);

  const { handleClose } = useCommonFunctionHooks();
  const isCompleteProctoring =
  Alert.testData.proctored === constants.PROCTORING_MODE.TAB_CAM ||
  Alert.testData.proctored === constants.PROCTORING_MODE.TAB_CAM_LOC;
  const steps =
    Alert.testData.testmode === constants.MODE.TEST_MODE && isCompleteProctoring
      ? ["Acknowledgement", "System Check", "Instructions"]
      : [
          "Acknowledgement",
          "System Check",
          "Connect Phone",
          "Camera Placement",
          "Instructions",
        ];

  const handleNext = (data) => {
    Alert.setVerifyImg(null);

    if (data === "back") {
      handleClose();
      Alert.setCurrentStep((prev) => prev - 1);
    } else {
      Alert.setCurrentStep((prev) => prev + 1);
    }
  };

  return { steps, handleNext };
}
